export default "__VITE_PUBLIC_ASSET__56eb76e8__"